import React from 'react';
import { Transition } from 'react-transition-group';
import Logo from '../../../../assets/Logo.png';
import { Title, Button, IntroText, LogoStyle } from './styled';
import { INTRO_REGEX } from '../../../constants';
const Intro = ({ game, nextStep }) => {
  const startGame = () => {
    nextStep();
  };

  const introText = game?.playerGame?.introText.replace(INTRO_REGEX, '');

  const generateTitle = () => {
    let title = game?.playerGame?.titleGame;
    if (!title || title == undefined || title == null) {
      return 'Welkom bij Huisarrest!';
    } else {
      let titleReplace = {
        first_name: game?.name,
      };

      const newTitle = title.replace(/first_name/gi, function (matched) {
        return titleReplace[matched];
      });

      return newTitle.replace(INTRO_REGEX, '');
    }
  };

  return (
    <Transition timeout={4000} in={true} appear>
      {(status) => (
        <div className={`box box-${status}`}>
          <LogoStyle src={Logo} alt='Logo' />
          <Title>{generateTitle()}</Title>

          <IntroText>{introText}</IntroText>

          <Button onClick={startGame}>Start het spel</Button>
        </div>
      )}
    </Transition>
  );
};

export default Intro;
